// extracted by mini-css-extract-plugin
export default {"zoomModal":"N5-z"};